module.exports = __webpack_public_path__ + "static/img/model_haier.fe12c0c7.jpg";